import { render, staticRenderFns } from "./PaymentAdd.vue?vue&type=template&id=36b932a0&scoped=true&"
import script from "./PaymentAdd.vue?vue&type=script&lang=js&"
export * from "./PaymentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b932a0",
  null
  
)

export default component.exports